import ReceiptIcon from '@material-ui/icons/Receipt';
import BillingList from './billingDetailsList';

export default {
    icon: ReceiptIcon,
    list: BillingList,
};
